import { useWindowScroll } from "@uidotdev/usehooks";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const [{}, scrollTo] = useWindowScroll();

  useEffect(() => {
    scrollTo({ left: 0, top: 0, behavior: "smooth" });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
